import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

interface Review {
  id: number;
  title: string;
  description: string;
  rating: number;
  images: string[];
  author: string;
  date: Date;
}

interface RatingStat {
  rating: number;
  count: number;
  percentage: number;
}

@Component({
  selector: 'trpx-product-review',
  templateUrl: './product-review.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./product-review.component.scss'],
})
export class ProductReviewComponent implements OnInit, OnChanges {
  @Input() reviewDetails: any = [];
  @Input() totalResults: any;
  @Input() averageRating: any;
  @Input() reviewBreakDown: any;
  ratingStats: any;
  reviews: Review[] = [];
  selectedRating = 0;
  selectedFiles: File[] = [];
  showImageModal: boolean = false;
  imageList: string[] = [];
  currentImage: string = '';
  currentIndex: number = 0;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['reviewDetails']) {
      // You can trigger further processing if needed
      this.reviews = this.reviewDetails;
    }
    if (changes['reviewDetails']) {
      this.cdr.markForCheck(); // manually trigger detection
    }
  }
  ngOnInit(): void {
    this.reviews = this.reviewDetails;
    this.ratingStats = [
      { rating: 5, percentage: this.reviewBreakDown?.fiveStarPercentage },
      { rating: 4, percentage: this.reviewBreakDown?.fourStarPercentage },
      { rating: 3, percentage: this.reviewBreakDown?.threeStarPercentage },
      { rating: 2, percentage: this.reviewBreakDown?.twoStarPercentage },
      { rating: 1, percentage: this.reviewBreakDown?.oneStarPercentage },
    ];
  }

  openImageModal(images: string[], index: number) {
    this.imageList = images;
    this.currentIndex = index;
    this.currentImage = images[index];
    this.showImageModal = true;
  }

  closeImageModal() {
    this.showImageModal = false;
  }

  prevImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.currentImage = this.imageList[this.currentIndex];
    }
  }

  nextImage() {
    if (this.currentIndex < this.imageList.length - 1) {
      this.currentIndex++;
      this.currentImage = this.imageList[this.currentIndex];
    }
  }
}
